import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';

import Price from '../../price.component';

const useStyles = makeStyles(theme => ({
    raiseditem: {
        width: '100%',
        maxWidth: '440px',
        padding: '8px',
        boxSizing: 'border-box',
        cursor: 'pointer',
    },
    paper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        height: '80px',
        minHeight: '80px',
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: '4px 10px 4px 6px',
        justifyContent: 'center',
    },
    image: {
        height: '80px',
        minHeight: '80px',
        width: '80px',
        minWidth: '80px',
        borderRadius: '0px 4px 4px 0px',
    },
    title: {
        width: '100%',
        textAlign: 'right',
    },
    subtitle: {
        width: '100%',
        textAlign: 'right',
    },
    spacer: {
        width: '24px',
        height: '24px',
        minWidth: '24px',
        minHeight: '24px',
    },
}));

export default function MenuItemRaisedRTL(props) {
    const classes = useStyles();
    const { Item, openProductDetails } = props;

    const openDetails = () => {
        if (!Item.NoDetails) openProductDetails(Item)
    }

    return (
        <div className={classes.raiseditem}>
            <Paper className={classes.paper} elevation={3} onClick={openDetails}>
                {
                    Item.ThumbnailUrl && <img className={classes.image} alt={Item.Title} src={Item.ThumbnailUrl} />
                }
                <div className={classes.content}>
                    {
                        Item.Title && <div className={classes.title}><Typography color='textPrimary' variant='body1'>{Item.Title}</Typography></div>
                    }
                    {
                        Item.SubTitle && <div className={classes.subtitle}><Typography variant='body2' color='textSecondary'>{Item.SubTitle}</Typography></div>
                    }
                </div>
                <Price Item={Item} />
                {
                    (Item.NoDetails) ? <div className={classes.spacer} /> : <ArrowLeftIcon color='primary' />
                }
            </Paper>
        </div >
    );
}